import React, {useState} from 'react';
import {useTranslation, Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBook, faPhone, faEnvelope, faHandsHelping} from '@fortawesome/free-solid-svg-icons';
import {Modal, Button, Icon} from '@deviceinsight/ng-ui-basic-components';
import './UserHelpButton.less';

export const UserHelpButtonModal = ({open, onClose}: {open: boolean; onClose: (arg0: boolean) => void}) => {
	const {t} = useTranslation();
	const supportHotline = t('rafi.usermanual.supportHotline', {
		defaultValue: '+49 751 89 1170'
	});
	const supportEmail = t('rafi.usermanual.supportEmail', {
		defaultValue: 'support.kisme@rafi.de'
	});
	const linkToUserManual = t('rafi.usermanual.linkToUserManual', {
		defaultValue: 'https://kisme.rafi.de/documents/KISME-UserManual.pdf'
	});
	const linkToUserManualDisplayName = t('rafi.usermanual.linkToUserManualDisplayName', {
		defaultValue: 'User Manual'
	});
	const linkToHelpCenter = t('rafi.usermanual.linkToHelpCenter', {
		defaultValue: 'https://kisme.rafi.de/en/support'
	});
	const linkToHelpCenterDisplayName = t('rafi.usermanual.linkToHelpCenterDisplayName', {
		defaultValue: 'kisme.rafi.de/en/support'
	});
	return (
		<>
			{open && (
				<Modal
					header={<Trans i18nKey="rafi.usermanual.title">Can we help?</Trans>}
					content={
						<div className="user-help-button" data-testid="user-help-modal">
							<p>
								<FontAwesomeIcon icon={faBook} size={'sm'} className="help-header" />{' '}
								<Trans i18nKey="rafi.usermanual.download">Download</Trans>
								<br />
								<span className="help-text">
									<a href={linkToUserManual} target="_blank" rel="noopener noreferrer">
										{linkToUserManualDisplayName}
									</a>
								</span>
							</p>
							<p
								className="divider"
								style={{
									borderTop: '1px solid #ccc'
								}}
							/>
							<p>
								<FontAwesomeIcon icon={faPhone} size={'sm'} className="help-header" />{' '}
								<Trans i18nKey="rafi.usermanual.call">Call</Trans>
								<br />
								<span className="help-text">{supportHotline}</span>
							</p>
							<p
								className="divider"
								style={{
									borderTop: '1px solid #ccc'
								}}
							/>
							<p>
								<FontAwesomeIcon icon={faEnvelope} size={'sm'} className="help-header" />{' '}
								<Trans i18nKey="rafi.usermanual.email">Email</Trans>
								<br />
								<span className="help-text">
									<a href={`mailto:${supportEmail}`}>{supportEmail}</a>
								</span>
							</p>
							<p
								className="divider"
								style={{
									borderTop: '1px solid #ccc'
								}}
							/>
							<p>
								<FontAwesomeIcon icon={faHandsHelping} size={'sm'} className="help-header" />{' '}
								<Trans i18nKey="rafi.usermanual.tutorialFaqs">Tutorial & FAQs</Trans>
								<br />
								<span className="help-text">
									<a href={linkToHelpCenter} target="_blank" rel="noopener noreferrer">
										{linkToHelpCenterDisplayName}
									</a>
								</span>
							</p>
						</div>
					}
					footer={
						<div>
							<Button data-testid="close-user-help-center-button" onClick={onClose}>
								<Trans i18nKey="general.actions.close">Close</Trans>
							</Button>
						</div>
					}
				/>
			)}
		</>
	);
};

const UserHelpButton = () => {
	const [open, setOpen] = useState(false);
	return (
		<span id="user-help-button">
			<Button naked data-testid="user-help-button" onClick={() => setOpen(true)}>
				<Icon documentation />
			</Button>
			<UserHelpButtonModal open={open} onClose={() => setOpen(false)} />
		</span>
	);
};

export default UserHelpButton;
